/* Login */
export const HANDSHAKE_ACCEPTED = 'HANDSHAKE_ACCEPTED';
export const HANDSHAKE_REJECTED = 'HANDSHAKE_REJECTED';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

/* OIDC application */
export const GENERATE_OIDC_CLIENT_CREDENTIALS_START = 'GENERATE_OIDC_CLIENT_CREDENTIALS_START';
export const GENERATE_OIDC_CLIENT_CREDENTIALS_SUCCESS = 'GENERATE_OIDC_CLIENT_CREDENTIALS_SUCCESS';
export const GENERATE_OIDC_CLIENT_CREDENTIALS_FAIL = 'GENERATE_OIDC_CLIENT_CREDENTIALS_FAIL';
export const ADD_OIDC_APP_START = 'ADD_OIDC_APP_START';
export const ADD_OIDC_APP_SUCCESS = 'ADD_OIDC_APP_SUCCESS';
export const ADD_OIDC_APP_FAIL = 'ADD_OIDC_APP_FAIL';
export const UPDATE_APP_NAME = 'UPDATE_APP_NAME';
export const UPDATE_IS_PUBLIC_CLIENT = 'UPDATE_IS_PUBLIC_CLIENT';
export const ADD_OIDC_REDIRECT_URI = 'ADD_OIDC_REDIRECT_URI';
export const DELETE_OIDC_REDIRECT_URI = 'DELETE_OIDC_REDIRECT_URI';
export const UPDATE_OIDC_REDIRECT_URI = 'UPDATE_OIDC_REDIRECT_URI';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
